import type { GatsbyBrowser } from "gatsby";

export { default as wrapRootElement } from "./src/wrapRootElement";
export { default as wrapPageElement } from "./src/wrapPageElement";

export const shouldUpdateScroll: GatsbyBrowser["shouldUpdateScroll"] = ({
  prevRouterProps,
  routerProps,
}) => prevRouterProps?.location?.pathname !== routerProps?.location?.pathname;
